import { handleActions } from "redux-actions";

import { PayloadAction, combineReducers } from "@reduxjs/toolkit";

import {
  searchPeople,
  searchPeopleSuccess,
  searchPeopleFailure,
  clearSearch
} from "../actions";

import { searchPeopleData } from "src/types/form";


type Status = "IDLE" | "LOADING" | "SUCCESS" | "FAILURE";

type DefaultTemplatesType = {
  users: searchPeopleData[];
  status: Status;
};

const defaultState: DefaultTemplatesType = {
  users: [],
  status: "IDLE",
};

const users = handleActions(
  {
    [searchPeopleSuccess as any]: (_: searchPeopleData[], action: PayloadAction<searchPeopleData[]>) => {
      return action.payload;
    },
    [clearSearch as any]: () => []
  },
  defaultState.users
);

const status = handleActions(
  {
    [searchPeopleSuccess as any]: () => "SUCCESS",
    [searchPeople as any]: () => "LOADING",
    [searchPeopleFailure as any]: () => "FAILURE",
    [clearSearch as any]: () => "IDLE"
  },
  defaultState.status
);

const searchUsers = combineReducers({
  status,
  users
});

export { searchUsers };
